
export class Region {
    record_id: number;
    region_name___ru: string;
    region_name___kz: string;
    code_name: string;
}

export class Bank {
    record_id: number;
    bank_number: string;
    branch_number: string;
    company_name___ru: string;
    company_name___kz: string;
    company_name: string;
    bin: string;
    is_resident: boolean;
    bank_bic: string;
}

export class OrgType {
    record_id: number;
    org_type_name___ru: string;
    org_type_name___kz: string;
    code_name: string;
}

export class OrgBranch {
    record_id: number;
    suppl_region_rid: number;
    org_branch_name___ru: string;
    org_branch_name___kz: string;
    org_branch_number: number;
    region_code_name: string;
    org_branch_short_name: string;
}

export class Requests {
    record_id: number;
    request_date: Date;
    request_number: number;
    state_type_name___ru: string;
    state_type_name___kz: string;
    code_name: string;
    row_count: number;
    row_num: number;
    request_description: string;
    contract_number: string;
    show_edit: boolean;
    can_edit: boolean;
    show_attach: boolean;
    can_attach: boolean;
    show_suppl: boolean;
    can_suppl: boolean;
    show_send: boolean;
}

export class RequestsDTO {
    CRID: number;
    iLimit: number;
    iOffset: number;
}


export class Attachment {
    attatchment_type_rid: number;
    is_required: boolean;
    attach_type_name___ru: string;
    attach_type_name___kz: string;
    code_name: string;
    attach_date: number;
    attach_file_type: string;
    attach_file_name: string;
    attach_id: number;
    fileData: File;
    hash_sha: string;
}


export class SaveRequestDTO {
    contractor_rid: number;
    record_id: number;
    params: ParamData;
}

export class ParamData {
    phone_number: string;
    email: string;
    boss_pos_name: string;
    boss_fio: string;
    contractor_name: string;
    org_type: number;
    bank_name: number;
    iik_number: string;
    is_resident: boolean;
    region_name: number;
    contractor_jur_address2: string;
    contractor_fact_address2: string;
    azhk_org_branch: number;
    ap_fact_address2: string;
    assigned_power: number;
    as_email: string;
    as_post_address: string;
    as_mobile_phone: string;
    as_mobile_phone_messenger: string;
    as_mobile_phone_multimedia: string;

    constructor() {
        this.phone_number = "";
        this.email = "";
        this.boss_pos_name = "";
        this.boss_fio = "";
        this.contractor_name = "";
        this.org_type = null as any;
        this.bank_name = null as any;
        this.iik_number = "";
        this.is_resident = true;
        this.region_name = 1;
        this.contractor_jur_address2 = "";
        this.contractor_fact_address2 = "";
        this.azhk_org_branch = null as any;
        this.ap_fact_address2 = "";
        this.assigned_power = null as any;
        this.as_email = "";
        this.as_post_address = "";
        this.as_mobile_phone = "";
        this.as_mobile_phone_messenger = "";
        this.as_mobile_phone_multimedia = "";
    }
}

export class ReqDetail {
    code_name: string;
    param_value: any;
}

export class RequestDTO {
    RID: number;
}

export class ReqPlan {
    month: number;
    year: number;
    record_id: number;
    consumption_plan_value: number;
}

export class SavePlanDTO {
    record_id: number;
    params: ReqPlan[];
}

export class SaveFileDTO {
    attatchment_type_rid: number;
    RID: number;
    data: FormData;
}

export class SendReqDTO {
    CRRID: number;
    data: any;
}

export class DelReqDTO {
    CRRID: number;
}
export class AttachByCodeDTO {
    CCRID: number;
    CodeName: string;
}
export class SaveFileByCodeNameDTO {
    attatchment_type_code: string;
    RID: number;
    data: FormData;
}
export class SignedDTO {
    CCRID: number;
}